import React from 'react'
import { NavTitle, NavLink, NavBar, NavAnchor, NavRight, NavLeft } from './StyledComponents'
import oc from './oc'

const NavContainer = ({siteTitle}) => (
  <NavBar>
    <NavLeft>
      <NavTitle to="/">{siteTitle}</NavTitle>
    </NavLeft>

    <NavRight>
      <NavLink to="/artifacts" activeStyle={{color: `${oc.yellow[8]}`, }}>
        Artifact
      </NavLink>

      <NavLink to="/musings" activeStyle={{color: `${oc.yellow[8]}`, }}>
        Musings
      </NavLink>

      <NavLink to="/resume" activeStyle={{color: `${oc.yellow[8]}`, }}>
        C.V.
      </NavLink>

      <NavLink to="/about" activeStyle={{color: `${oc.yellow[8]}`, }}>
        About
      </NavLink>

      <NavLink to="/contact" activeStyle={{color: `${oc.yellow[8]}`, }}>
        Contact
      </NavLink>
      
      <NavAnchor href="https://beemployedwhenyougraduate.com">
        Book
      </NavAnchor>
    </NavRight>
  </NavBar>
)

export default NavContainer



// WEBPACK FOOTER //
// ./src/components/NavBar.js